// extracted by mini-css-extract-plugin
module.exports = {"tocContainer":"TableOfContents_tocContainer__Pl6ca","tocList":"TableOfContents_tocList__3O4h1","tocItem":"TableOfContents_tocItem__lOzVV","active":"TableOfContents_active__RdAMp"};